/**
 * @ngdoc directive
 * @name cbl.telepass.wa.directive:tlpsDefinizioneProdotto
 * @restrict E
 * @description Componente che gestisce il primo step "Stato Affidamento" del
 *              dettaglio pratica
 */
(function() {
  'use strict';
  var TlpsDefinizioneProdottoCtrl = function(
    $scope,
    $stateParams,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaTelepassSrvc,
    uiGridConstants,
    userSrvc
    // propostaDefinizioneSrvc
  ) {
    this.$stateParams = $stateParams;
    this.messaggiFctr = messaggiFctr;
    this.CONSTANTS = CONSTANTS;
    this.uiGridConstants = uiGridConstants;
    this.gridApi = null;
    this.userSrvc = userSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.propostaTelepassSrvc = propostaTelepassSrvc;

    // Spinner
    this.spinner = this.propostaTelepassSrvc.spinner;

    this.idPratica;
    this.idProdotto;
    // Conto selezionato dall'utente per proseguire la pratica
    this.contoSelezionato = undefined;

    // Opzioni della tabella dei conti
    this.gridOptions = {};
    this.tableHeight = 0;
    this.contiCorrenti;

    this.opzioniTelepassLista = [];

    this.datepicker = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };

    var self = this;

    /*
     * -------------------------------------
     *          GESTIONE INTERFACCIA
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name cambiaApparatoAggiuntivo
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Aggiorna la selezione del apparato aggiuntivo secondo la opzione telepass selezionata
     */
    // this.cambiaApparatoAggiuntivo = function() {
    //   if (
    //     !self.propostaTelepassSrvc.datiPratica.opzione ||
    //     self.propostaTelepassSrvc.datiPratica.opzione.codice !== 'PR'
    //   ) {
    //     self.propostaTelepassSrvc.datiPratica.twin = false;
    //   } else {
    //     self.propostaTelepassSrvc.datiPratica.twin = null;
    //   }
    // };

    /**
     * @ngdoc method
     * @name svuotaCodicePromozione
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Svuota il codice promozione se viene selezionato 'no'
     */
    this.svuotaCodicePromozione = function() {
      self.propostaTelepassSrvc.datiPratica.codicePromozione = null;
    };

    this.eliminaDatiApparatoAggiuntivo = function() {
      if (self.propostaTelepassSrvc.datiPratica.nazioneTargaTwin) {
        self.propostaTelepassSrvc.datiPratica.nazioneTargaTwin = null;
      }

      if (self.propostaTelepassSrvc.datiPratica.targaTwin) {
        self.propostaTelepassSrvc.datiPratica.targaTwin = null;
      }
    };

    /**
     * @ngdoc method
     * @name selezionaConto
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Seleziona o deseleziona il conto corrente su cui aprire la pratica
     */
    this.selezionaConto = function(conto) {
      if (
        self.propostaTelepassSrvc.datiPratica.numeroRapporto !==
        conto.entity.numeroRapporto
      ) {
        self.propostaTelepassSrvc.datiPratica.numeroRapporto =
          conto.entity.numeroRapporto;
      } else {
        self.propostaTelepassSrvc.datiPratica.numeroRapporto = null;
      }
    };

    /*
     * -------------------------------------
     *          GESTIONE BOTTONI
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name datiValidi
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Verifica che i campi obbligatori siano valorizzati correttamente.
     */
    this.propostaTelepassSrvc.datiValidi = function() {
      var errori = false;

      //Controlla che un conto sia stato selezionato
      if (!self.propostaTelepassSrvc.datiPratica.numeroRapporto) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve selezionare un conto'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Viacard, abbia il numero di carte
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '31' &&
        !self.propostaTelepassSrvc.datiPratica.numeroCarte
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve indicare il numero di carte'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, sia stata selezionata la opzione
      // if (
      //   self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
      //   !self.propostaTelepassSrvc.datiPratica.opzione
      // ) {
      //   var message = {};
      //   message.type = 'E';
      //   message.message = 'Si deve selezionare la opzione Telepass'; //chiedere messaggio corretto
      //   messaggiFctr.addMessage(message);
      //   errori = true;
      // }

      //Controlla se la pratica è Telepass, e si abbia scelto la opzione 'posesso codice promozionale', questa sia valorizzata
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.posessoCodicePromozionale === 'si' &&
        !self.propostaTelepassSrvc.datiPratica.codicePromozione
      ) {
        var message = {};
        message.type = 'E';
        message.message = 'Si deve valorizzare il codice promozione'; //chiedere messaggio corretto
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, sia valorizzata la opzione 'Apparato Aggiuntivo'
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.twin === null &&
        (!self.propostaTelepassSrvc.datiPratica.opzione ||
          self.propostaTelepassSrvc.datiPratica.opzione.codice !== 'PR')
      ) {
        self.propostaTelepassSrvc.datiPratica.twin = false;
      } else if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        self.propostaTelepassSrvc.datiPratica.twin === null &&
        self.propostaTelepassSrvc.datiPratica.opzione.codice === 'PR'
      ) {
        var message = {};
        message.type = 'E';
        message.message =
          'Si deve selezionare l`Apparato Aggiuntivo (Telepass Twin)';
        messaggiFctr.addMessage(message);
        errori = true;
      }

      //Controlla se la pratica è Telepass, se non viene valorizzato il campo data sottoscrizione contratto, viene aggiunto un messaggio.
      if (
        self.propostaTelepassSrvc.datiProdotto.settoreProdotto === '30' &&
        !self.propostaTelepassSrvc.datiPratica.dataSottoscrizioneContratto
      ) {
        var message = {};
        message.type = 'I';
        message.message =
          'La data di sottoscrizione del contratto coinciderà con la data di completamento della pratica';
        messaggiFctr.addMessage(message);
      }

      if (errori) {
        return false;
      }

      return true;
    };

    this.aggiornaOpzionePerTwin = function() {
      var opzione = document.getElementById('opzioneTelepass');
      if (self.propostaTelepassSrvc.datiPratica.twin === true) {
        self.propostaTelepassSrvc.datiPratica.opzione = {
          codice: 'PR',
          descrizione: 'PREMIUM',
          canale: 'BRIO_FILIALE',
          prodotto: 'TEL01'
        };
      }
    };

    /**
     * @ngdoc method
     * @name datiValidi
     * @methodOf cbl.telepass.wa:tlpsDefinizioneProdotto
     * @description Setta a null la opzione telepass se questa non viene valorizzata
     */
    this.controllaOpzioniTelepassVuoto = function() {
      if (self.propostaTelepassSrvc.datiPratica.opzione === '') {
        self.propostaTelepassSrvc.datiPratica.opzione = null;
      }
    };

    /*
     * -------------------------------------
     * METODI INIZIALIZZAZIONE
     * -------------------------------------
     */
    this.init = function() {
      self.ndg = self.$stateParams.ndg;
      self.idProdotto = self.$stateParams.idProdotto;
      self.idPratica = self.$stateParams.idPratica;
      // messaggiFctr.resetMessages();

      if (self.propostaTelepassSrvc.datiPratica.codicePromozione) {
        self.posessoCodicePromozionale = 'si';
      } else {
        self.posessoCodicePromozionale = 'no';
      }

      self.codicePromozione = '';
      self.apparatoAggiuntivo = 'no';

      self.spinner.showSpinner = true;

      self.propostaTelepassSrvc
        .promiseRecuperaContiCorrenti(self.ndg)
        .then(function(response) {
          self.contiCorrenti = response.data.result;
          self.tableHeight = response.data.result.length * 30 + 40;

          for (var i in self.contiCorrenti) {
            self.contiCorrenti[
              i
            ].dataApertura = self.propostaTelepassSrvc.formattazioneData(
              self.contiCorrenti[i].dataApertura
            );
          }
          // // Configurazione tabella
          self.gridOptions = {
            enableSorting: true,
            enableColumnMenus: false,
            enableGrouping: false,
            multiSelect: false,
            showHeader: true,
            enableRowHeaderSelection: false,
            enableRowSelection: !self.propostaTelepassSrvc.isPraticaNavigabile(),
            showGridFooter: false,
            enableVerticalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableHorizontalScrollbar: self.uiGridConstants.scrollbars.NEVER,
            enableColumnResizing: true,
            columnDefs: [
              {
                displayName: 'Numero Rapporto',
                field: 'numeroRapporto',
                width: '10%',
                name: 'numeroRapporto'
              },
              {
                displayName: 'Iban',
                field: 'iban',
                width: '25%',
                name: 'iban'
              },
              {
                displayName: 'Descrizione',
                field: 'descrizione',
                width: '15%',
                name: 'descrizione'
              },
              {
                displayName: 'Saldo Contabile',
                cellFilter: 'number : 2',
                cellClass: 'right',
                field: 'saldoContabile',
                width: '10%',
                name: 'saldoContabile'
              },
              {
                displayName: 'Intestatario',
                cellClass: 'right',
                field: 'intestazione',
                width: '20%',
                name: 'intestazione'
              },
              {
                displayName: 'Stato',
                field: 'stato',
                width: '10%',
                name: 'stato'
              },
              {
                displayName: 'Data Apertura',
                field: 'dataApertura',
                cellFilter: 'date: "dd/MM/yyyy"',
                width: '10%',
                name: 'dataApertura'
              }
            ],
            data: self.contiCorrenti,
            onRegisterApi: function(gridApi) {
              self.gridApi = gridApi;
              self.gridApi.grid.modifyRows(self.gridOptions.data);

              // Se era già stato salvato il conto corrente lo recupero e lo seleziono
              if (
                self.propostaTelepassSrvc.datiPratica &&
                self.propostaTelepassSrvc.datiPratica.numeroRapporto
              ) {
                angular.forEach(self.contiCorrenti, function(conto, index) {
                  if (
                    conto.numeroRapporto ===
                    self.propostaTelepassSrvc.datiPratica.numeroRapporto
                  ) {
                    self.gridApi.selection.selectRow(self.contiCorrenti[index]);
                    self.contoSelezionato = self.contiCorrenti[index];
                  }
                });
              }

              gridApi.selection.on.rowSelectionChanged($scope, function(row) {
                self.selezionaConto(row);
              });
            }
          };

          self.propostaTelepassSrvc
            .promiseRecuperaOpzioniTelepass(
              self.propostaTelepassSrvc.datiProdotto.codiceProdottoCPT
            )
            .then(function(response) {
              self.opzioniTelepassLista = response.data.result;
              self.spinner.showSpinner = false;
            });
        });
    };

    /*
     * -------------------------------------
     *        INIZIALIZZAZIONE
     * -------------------------------------
     */
    self.init();
  };

  TlpsDefinizioneProdottoCtrl.$inject = [
    '$scope',
    '$stateParams',
    'TLPS_CONSTANTS',
    'TlpsLabelSrvc',
    'TlpsMessaggiFctr',
    'TlpsPropostaSrvc',
    'uiGridConstants',
    'TlpsUserSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'tlpsProposta/tlpsDefinizione/tlpsDettaglioProdotto/tlpsDettaglioProdotto.html'
    );
  };

  TemplateUrl.$inject = ['TLPS_CONSTANTS'];

  var tlpsDefinizioneProdottoComponent = {
    bindings: {},
    controller: TlpsDefinizioneProdottoCtrl,
    controllerAs: 'definizioneCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.telepass.wa')
    .component('tlpsDefinizioneProdotto', tlpsDefinizioneProdottoComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/tlpsProposta/tlpsDefinizione/tlpsDettaglioProdotto/tlpsDettaglioProdotto.cmpt.js
// module id = 30
// module chunks = 0